import ArticleCard from "@/components/articleCard";
import Divider from "@/components/divider";
import ToolComponent from "@/components/home/hero/Tool";
import SpotlightArticle from "@/components/spotlightArticle";
import { Article, Tool, Maybe } from "@/graphql/gql/graphql";
import styles from "./template3ColumnWithTools.module.scss";

type Template3ColumnWithToolsProps = {
  col1Article: Article;
  col2Articles: Article[];
  col3Tools: Maybe<Tool>[];
};

const Template3ColumnWithTools = ({
  col1Article,
  col2Articles = [],
  col3Tools = [],
}: Template3ColumnWithToolsProps) => {
  const {
    title,
    description,
    slug,
    subHeading,
    firstPublishedAt,
    hero,
    author,
    sport: { name: sportName, slug: sportSlug },
  } = col1Article;

  return (
    <div className={styles.container}>
      <div className={styles.spotlightArticle}>
        <SpotlightArticle
          author={author}
          fullwidthMobileImage
          image={hero?.imageUrl?.url}
          link={`/${slug}`}
          origin="home_sport_articles"
          publishedOn={firstPublishedAt}
          snippet={subHeading ?? description}
          sportName={sportName}
          sportSlug={sportSlug}
          tagType="info"
          title={title}
        />
      </div>
      <div className={styles.articles}>
        {col2Articles.map((article, idx) => (
          <div key={article.id}>
            <ArticleCard
              author={article.author}
              image={article.hero?.imageUrl?.url}
              link={`/${article.slug}`}
              origin="home_sport_articles"
              publishedOn={article.firstPublishedAt}
              sportName={article.sport.name}
              sportSlug={article.sport.slug}
              title={article.title}
              displayHorizontal
            />
            {idx < col2Articles.length - 1 && <Divider color="light" />}
          </div>
        ))}
      </div>
      <div className={styles.toolsContainer}>
        <div className={styles.toolsLayout}>
          {col3Tools.map((tool) => (
            <ToolComponent
              origin="home_tool_list"
              key={`${tool?.title}-${tool?.url}`}
              description={tool?.title ?? ""}
              title={tool?.title ?? ""}
              url={tool?.url ?? ""}
              newWindow={tool?.newWindow}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Template3ColumnWithTools;
